const { Component, Fragment } = wp.element;
import * as Switches from './../../switches';



class DarkModeSwitch extends Component {

    // Default props.
    static defaultProps = {
        style: 1,
        size: 1,
        reactive: true
    };

    render() {
        const props = { ...DarkModeSwitch.defaultProps, ...this.props };
        const { style, size, reactive } = props;

        const switchStyle = 'Switch_' + (style || 1);
        const html = Switches[switchStyle]({
            style,
            size
        });

        return (
            <Fragment>
                <div
                    className={`wp-dark-mode-ignore wp-dark-mode-switch-${style || 1} ${WPDarkMode.isActive && reactive ? 'active' : ''}`}
                    style={{ '--wpdm-switch-scale': size || 1 }}
                    dangerouslySetInnerHTML={{ __html: html }}
                ></div>
            </Fragment>

        );
    }
}

export default DarkModeSwitch;
